/* =====================
   ALL WORKS (45 PROJECTS)
   ===================== */
export interface WorkItem {
  id: string;
  title: string;
  meta: string;
  year: string;
  category: string;
  cover?: string;
  extraCategories?: string[];
}

export const allWorks: WorkItem[] = [
  // BRAND / CX
  {
    id: 'baby-me-belk',
    title: 'BABY&Me BELK.',
    meta: 'Brand Strategy / Product / Web / Event',
    year: '2019–2022',
    category: 'brand-cx',
    cover: '/assets/migrated/072afa1777eb7543c426.png',
  },
  {
    id: 'amino-index',
    title: 'amino index',
    meta: 'Brand Strategy / Communication / VI',
    year: '2021',
    category: 'brand-cx',
    cover: '/assets/migrated/11afc223bd9c26f559d7.png',
  },
  {
    id: 'aizu-coin',
    title: 'AIZU COIN ブランドコミュニケーション戦略',
    meta: 'Brand Strategy / CX / Communication',
    year: '2024',
    category: 'brand-cx',
    cover: '/assets/migrated/4ff28ff02d8125038c1d.webp',
  },
  {
    id: 'unite-card',
    title: 'UNiTe Card',
    meta: 'Naming / VI / Retail / Web / TV-CM',
    year: '2021–2022',
    category: 'brand-cx',
    cover: '/assets/migrated/e2bcd84c6a6759dcca16.png',
  },
  {
    id: 'regional-currency-20',
    title: 'LVP 2.0 ブランド戦略',
    meta: 'Brand Strategy / Communication Design',
    year: '2024',
    category: 'brand-cx',
    cover: '/assets/migrated/62a664f6008835cde98f.webp',
  },
  {
    id: 'saitama-wood-terrace',
    title: 'SAITAMA WOOD TERRACE',
    meta: 'Brand Story / Motion / Promotion',
    year: '2025',
    category: 'brand-cx',
    cover: '/assets/migrated/9c224fa8d10550998358.png',
  },
  {
    id: 'reganet',
    title: 'Reganet',
    meta: 'Retail CI / VI / Spatial',
    year: '2012',
    category: 'brand-cx',
    cover: '/assets/migrated/ca11547a06f92049de5e.png',
  },
  {
    id: 'aseed-aster',
    title: 'ASEED ASTER',
    meta: 'Branding / Promotion',
    year: 'Archive',
    category: 'brand-cx',
    cover: '/assets/migrated/577984cb6edeee6ad15d.png',
  },
  {
    id: 'chefs-pride',
    title: "CHEF'S CRAFT",
    meta: 'Branding / Product',
    year: 'Archive',
    category: 'brand-cx',
    cover: '/assets/migrated/9f95f79526199ada2518.png',
  },
  // DIGITAL / SERVICE
  {
    id: 'remo-cart',
    title: 'REMO CART',
    meta: 'Service Brand / App / Retail',
    year: '2022',
    category: 'digital-service',
    cover: '/assets/migrated/4ed08731fe9847b9b0e3.png',
  },
  {
    id: 'token-branding',
    title: 'トークン活用型 ブランディング戦略 PROJECT',
    meta: 'Business Design / Web3 / Brand / Web Design',
    year: '2024',
    category: 'digital-service',
    cover: '/assets/migrated/a404d9b646169c8ab95d.webp',
  },
  {
    id: 'jtb-web3',
    title: 'JTB × web3 FAN Tourism — 旅と地域を結ぶ新戦略',
    meta: 'Business / Service / Digital',
    year: '2024',
    category: 'digital-service',
    cover: '/assets/migrated/db1d1d1a3b0cc4f2060b.png',
  },
  {
    id: 'fujitsu-recruit',
    title: 'FUJITSU Recruitment Branding',
    meta: 'Brand / CX / UX/UI / Web',
    year: '2022',
    category: 'digital-service',
    cover: '/assets/migrated/fa1f23c201b1e414322d.png',
  },
  {
    id: 'sompo-himawari',
    title: 'SOMPO Himawari Life',
    meta: 'Recruitment Branding / Web',
    year: 'Archive',
    category: 'digital-service',
    cover: '/assets/migrated/a3063e773c791568a599.png',
  },
  {
    id: 'yanjan-blue-membership',
    title: 'ヤンジャンアプリ BLUEメンバーシップ UXデザイン',
    meta: 'UX Design / App / Subscription',
    year: '2024',
    category: 'digital-service',
    cover: '/assets/migrated/f1682af4ad4f8f2322c1.webp',
  },
  {
    id: 'sb-cs',
    title: 'SB C&S',
    meta: 'Recruitment Branding / Web',
    year: 'Archive',
    category: 'digital-service',
    cover: '/assets/migrated/9b2277ea786d324debea.png',
  },
  {
    id: 'hitachi-solutions',
    title: 'Hitachi Solutions Create',
    meta: 'Recruitment Branding / Web',
    year: 'Archive',
    category: 'digital-service',
    cover: '/assets/migrated/ab1448b5909f6a92de5d.jpg',
  },
  {
    id: 'hitachi-social',
    title: 'Hitachi Social Info Service',
    meta: 'Web / UX/UI / Recruitment',
    year: 'Archive',
    category: 'digital-service',
    cover: '/assets/migrated/b7ccd72f0c51555e8f24.jpg',
  },
  {
    id: 'ctc-system',
    title: 'CTC System Management',
    meta: 'Web / UX/UI / Recruitment',
    year: 'Archive',
    category: 'digital-service',
    cover: '/assets/migrated/51d84595dff6c9fa729e.png',
  },
  {
    id: 'sheaful-wellbeing',
    title: 'シアフル Well-being アプリ UX/UI リデザイン',
    meta: 'UX/UI / Behavioral Design / Well-being',
    year: '2025',
    category: 'digital-service',
    cover: '/assets/migrated/dadee656193160a35a81.webp',
  },
  // EXPERIENCE / SPACE
  {
    id: 'aqua-park-shinagawa',
    title: 'アクアパーク品川 ブランディング',
    meta: 'Facility Rebranding / Launch / Movie',
    year: '2015',
    category: 'experience-space',
    extraCategories: ['creative-movie'],
    cover: '/assets/migrated/a08827d4cb17c74b2663.png',
  },
  {
    id: 'nisshin-wanokiwami',
    title: 'Nisshin Petfood — JP STYLE',
    meta: 'Experience / Spatial / Event',
    year: '2015',
    category: 'experience-space',
    cover: '/assets/migrated/3f07bfdc8f78ead8dbed.png',
  },
  {
    id: 'nisshin-seven-musubi',
    title: 'Nisshin Petfood — Seven Musubi',
    meta: 'Experience / Spatial / Event',
    year: '2016',
    category: 'experience-space',
    cover: '/assets/migrated/1c551e0a6c557bb8ce68.png',
  },
  {
    id: 'tokyo-gas-eco',
    title: 'Tokyo Gas ECO PRODUCTS 2014',
    meta: 'Experience / Spatial / Education',
    year: 'Archive',
    category: 'experience-space',
    cover: '/assets/migrated/b58534a7bea4e8aab9fb.jpg',
  },
  {
    id: 'j-milk-dietetic',
    title: 'J-MILK x Dietetic Association',
    meta: 'Experience / Retail / Event',
    year: 'Archive',
    category: 'experience-space',
    cover: '/assets/migrated/af09e700dbc0dfbfaea1.jpg',
  },
  {
    id: 'baby-me-event',
    title: 'BABY&Me BELK. Event',
    meta: 'Event / Brand Experience',
    year: 'Archive',
    category: 'experience-space',
    cover: '/assets/migrated/aa3dee3d203d486fef81.jpg',
  },
  {
    id: 'jww-tisi',
    title: 'JWW TISI Exhibition',
    meta: 'B2B Event / Spatial / Token',
    year: '2024',
    category: 'experience-space',
    cover: '/assets/migrated/7eda9b2028a9fd4b3161.jpg',
  },
  // RETAIL / COMMUNICATION
  {
    id: 'kinsho-65th',
    title: 'KINSHO 65th Anniversary',
    meta: 'Retail Promotion',
    year: 'Archive',
    category: 'retail-communication',
    cover: '/assets/migrated/5ce792b8bfd67dae4c53.png',
  },
  {
    id: 'transino',
    title: 'TRANSINO',
    meta: 'Retail / Trial Promotion',
    year: 'Archive',
    category: 'retail-communication',
    cover: '/assets/migrated/71e79b30876a0e1224b1.webp',
  },
  {
    id: 'android-retail',
    title: 'Android Retail Strategy',
    meta: 'Retail Strategy / Promotion',
    year: 'Archive',
    category: 'retail-communication',
    cover: '/assets/migrated/a709508230da27bbdf8c.png',
  },
  {
    id: 'saran-wrap',
    title: 'サランラップ カラフル3色フラワープレゼント',
    meta: 'Campaign / Retail / Promotion',
    year: '2015',
    category: 'retail-communication',
    cover: '/assets/migrated/98615e6b02687f1c81ff.webp',
  },
  {
    id: 'otona-furikake',
    title: 'Otona-no-Furikake',
    meta: 'Category Reframing',
    year: 'Archive',
    category: 'retail-communication',
    cover: '/assets/migrated/03256a31743c7967f80a.png',
  },
  {
    id: 'patex',
    title: 'Patex Functional Supporter',
    meta: 'Retail / Communication',
    year: 'Archive',
    category: 'retail-communication',
    cover: '/assets/migrated/5f81a1f9bbb0d05f36fb.png',
  },
  {
    id: 'soflan',
    title: 'Soflan Aroma Rich',
    meta: 'Retail / Sensory Experience',
    year: 'Archive',
    category: 'retail-communication',
    cover: '/assets/migrated/821c68c890ded52f94c7.png',
  },
  {
    id: 'ziploc',
    title: 'Ziploc',
    meta: 'Retail / Campaign / Experience',
    year: 'Archive',
    category: 'retail-communication',
    cover: '/assets/migrated/75aacd1398ac680e30bd.png',
  },
  // CREATIVE / MOVIE
  {
    id: 'nisshin-petfood-tvcm',
    title: '日清ペットフード TV-CM',
    meta: 'TV-CM / Communication',
    year: '2016',
    category: 'creative-movie',
    cover: '/assets/migrated/c9ba1cd86146d0843864.png',
  },
  {
    id: 'unite-card-tvcm',
    title: 'UNiTe Card TV-CM',
    meta: 'TV-CM / Communication',
    year: '2022',
    category: 'creative-movie',
    cover: '/assets/migrated/60b6f1df561e170e3383.png',
  },

  {
    id: 'paper-glass',
    title: 'PAPER GLASS',
    meta: 'Product / Promotion / Creative',
    year: '2015',
    category: 'creative-movie',
    cover: '/assets/migrated/316079c6944587387373.png',
  },
  {
    id: 'android-promo',
    title: 'Android Promotion',
    meta: 'Promotion / Retail / Digital',
    year: 'Archive',
    category: 'creative-movie',
    cover: '/assets/migrated/8245cf13f9ecb52977f5.jpg',
  },
  {
    id: 'kao-info',
    title: 'Kao Information Meeting & Retail Strategy',
    meta: 'Retail Strategy / Experience',
    year: 'Archive',
    category: 'creative-movie',
    cover: '/assets/migrated/805a9f8904e63d49d792.png',
  },
  {
    id: 'plus-keshipon',
    title: 'PLUS ケシポン 大きな文字用',
    meta: 'Retail Tool / Promotion',
    year: 'Archive',
    category: 'creative-movie',
    cover: '/assets/migrated/8655f9bf72f544ecceb8.jpg',
  },
  {
    id: 'q-sai-aojiru',
    title: 'Q-SAI 青汁 ブランド戦略・PROMOTION企画',
    meta: 'Brand Strategy / Promotion Planning / Package Design',
    year: 'Archive',
    category: 'brand-cx',
    extraCategories: ['creative-movie'],
    cover: '/assets/migrated/e1eed88ed7cb0cbfdaa7.webp',
  },
  // 丸紅パケメイト
  {
    id: 'marubeni-packetmate',
    title: '丸紅+TISI パケメイト',
    meta: 'Branding / Service / Business Design',
    year: '2024',
    category: 'digital-service',
    cover: '/assets/migrated/d7f7499f46342f6c9816.webp',
  },
  // AIZU COIN ブランドデザインガイドライン
  {
    id: 'aizu-coin-design-guideline',
    title: 'AIZU COIN ブランドデザインガイドライン',
    meta: 'Brand Design Guideline / VI / Character / UI System',
    year: '2024',
    category: 'brand-cx',
    cover: '/assets/migrated/bb349efa1d202e91a373.webp',
  },
  // グリーンインフラ グランド (旧YOKOZEMACHI + Green Infraを統合)
  {
    id: 'green-infra',
    title: 'グリーンインフラプロジェクト',
    meta: 'GI / GX Branding / Regional Experience / Spatial',
    year: '2025',
    category: 'brand-cx',
    cover: '/assets/migrated/fea614222907288bafdc.png',
  },
  // アフォーダンスデザイン研究 — EXPERIENCE / SPACE (ARCHIVE)
  {
    id: 'origin-design-thinking',
    title: 'デザイン思考の原点 — アフォーダンス研究と空間・体験設計',
    meta: 'ARCHIVE / RESEARCH / EXPERIENCE',
    year: 'Archive',
    category: 'experience-space',
    cover: '/assets/migrated/efaeb2b2b6b3952f2f4f.webp',
  },
];

/* =====================
   PROFILE IMAGES (from Adobe Portfolio)
   ===================== */
export const profileImages = {
  portrait: '/assets/migrated/9666961950a44b0a2f3e.png',
  portrait2: '/assets/migrated/effe64a43719b2163da5.png',
  dogs: '/assets/migrated/b2a61b44b404a87d8d53.png',
  dog2: '/assets/migrated/589decd752a42c04b0e0.png',
  dog3: '/assets/migrated/23f3c2bc6c06d7d62ad8.png',
};

/* =====================
   NAVIGATION
   ===================== */
export const navSections = [
  { id: 'positioning', label: 'What I Do' },
  { id: 'approach', label: 'Approach' },
  { id: 'works', label: 'Works' },
  { id: 'career', label: 'Career' },
  { id: 'profile', label: 'About' },
  { id: 'contact', label: 'Contact' },
];

/* =====================
   HERO
   ===================== */
export const heroStats = [
  { k: '20+', v: 'Years' },
  { k: '100+', v: 'Projects' },
  { k: '5', v: 'Industries' },
  { k: '6', v: 'Approach Steps' },
];

/* =====================
   WHAT I DO / CAPABILITY
   ===================== */
export const capabilities = {
  strategy: [
    'Business Design',
    'Brand Strategy',
    'CX Planning',
    'Communication Strategy',
  ],
  experience: [
    'Service & Experience Design',
    'Customer Journey',
    'Touchpoint Design',
    'UX / UI Planning',
  ],
  implementation: [
    'Creative Direction',
    'Web / Movie',
    'Retail / Spatial',
    'VI / Graphic',
    'Event / Promotion',
  ],
};

/* =====================
   MY APPROACH
   ===================== */
export const approachSteps = [
  {
    no: '01',
    title: 'UNDERSTAND',
    subtitle: 'Business / Market / User',
    desc: '事業・市場・顧客・サービスの状況を理解する。マーケティング分析から、課題の全体像を把握する。',
  },
  {
    no: '02',
    title: 'DEFINE',
    subtitle: 'Issue / Value / Opportunity',
    desc: '本質的な課題、提供価値、機会領域を定義する。表層ではなく構造的な課題を捉え直す。',
  },
  {
    no: '03',
    title: 'STRATEGY',
    subtitle: 'Brand / CX / Communication',
    desc: 'ブランド、顧客体験、コミュニケーションの戦略を設計する。方向性と価値をひとつの軸に統合する。',
  },
  {
    no: '04',
    title: 'DESIGN',
    subtitle: 'Message / Experience / Touchpoint',
    desc: 'メッセージ、体験、顧客接点を設計する。戦略を具体的な体験の構造へ変換する。',
  },
  {
    no: '05',
    title: 'CREATE',
    subtitle: 'Creative / Service / Promotion',
    desc: 'サービス、クリエイティブ、プロモーションへ具体化する。表現・実装・展開を一貫してリードする。',
  },
  {
    no: '06',
    title: 'ACTIVATE',
    subtitle: 'Launch / Engagement / Improvement',
    desc: '市場・顧客との接点をつくり、反応を次の改善へつなげる。効果検証と継続的改善のサイクルを回す。',
  },
];

/* =====================
   CURRENT FOCUS
   ===================== */
export const currentWorks = [
  {
    id: 'aizu-coin',
    title: 'AIZU COIN ブランドコミュニケーション戦略',
    category: 'Brand Strategy / CX / Communication',
    year: '2024',
    focus: 'Business Design / CX / Brand Strategy',
    desc: '地域通貨を市民と地域をつなぐ体験プラットフォームとして再定義。ブランドストーリー、VI、キャラクター、Webまで統合的に設計。日常消費から地域の魅力再発見・観光誘導まで一貫した体験を構築する。',
    image: '/assets/migrated/5754cdef7fa3a5937319.webp',
    mobileImage: '/assets/migrated/a72aa86f43f3d5da7e66.webp',
  },
  {
    id: 'regional-currency-20',
    title: 'LVP 2.0 ブランド戦略',
    category: 'Brand Strategy / Communication Design',
    year: '2024',
    focus: 'Business Design / CX Planning / Brand Strategy',
    desc: '地域通貨を、行政・金融・事業者・市民をつなぐ次世代の体験基盤として再定義。複雑なステークホルダー構造を一つのプラットフォームとして体験設計。',
    image: '/assets/migrated/62a664f6008835cde98f.webp',
  },
  {
    id: 'green-infra',
    title: 'グリーンインフラプロジェクト',
    category: 'GI / GX Branding / Regional Experience',
    year: '2025',
    focus: 'Brand Strategy / Naming / VI / Experience Design / Creative Direction',
    desc: '地域資産を一つの体験ブランドとして統合。グリーンインフラを「森のインターフェース」と定義し、環境価値・Green Festival Gate・地域体験をブランドとして統合設計。',
    image: '/assets/migrated/fea614222907288bafdc.png',
  },
  {
    id: 'baby-me-belk',
    title: 'BABY&Me BELK.',
    category: 'Brand Development',
    year: '2019–2022',
    focus: 'Brand Strategy / CX / Creative Direction',
    desc: 'BELK.（Berg=山の意）として新ブランドを立ち上げ。ヒップシートは登山のリュックから発想を得た商品であり、「最高峰の登山を家族で成し得る」コミュニケーションコンセプトで展開。GOOD DESIGN AWARD 2021・KIDS DESIGN AWARD 2021 受賞。',
    image: '/assets/migrated/072afa1777eb7543c426.png',
  },
  {
    id: 'aqua-park-shinagawa',
    title: 'アクアパーク品川 ブランディング',
    category: 'Facility Rebranding / Launch',
    year: '2015',
    focus: 'Brand Strategy / Creative Direction / Spatial / Launch',
    desc: '10周年を迎える品川アクアスタジアムを、国際戦略総合特区・品川の新エンターテイメント施設としてリブランディング。「遊びによくばりな街。」をコンセプトに、VI/LOGOデザインからカウントダウンOOH、100人レインボーダー企画まで一貫した世界観を設計。',
    image: '/assets/migrated/a08827d4cb17c74b2663.png',
  },
];

/* =====================
   SELECTED CASE STUDIES
   ===================== */
export const selectedCases = [
  {
    id: 'yanjan-blue-membership',
    title: 'ヤンジャンアプリ BLUE UXデザイン',
    category: 'UX Design / App / Subscription',
    year: '2024',
    role: 'UX Design / Service Design / Behavioral Design',
    issue: 'ヤンジャンアプリのBLUEメンバーシップ（月額980円）の加入率向上。既存読者が「いいかも！」と思える体験設計が課題。「待てばゼロ円」読者をサブスク入会へ導くための動機形成が求められている。',
    value: 'ザイオンス効果で「面白いマンガとの出会いやすさ」をデザイン。「友達の家の本棚」履歴共有と「昂ったページにいいね」機能、心理学に基づくUI改善を三柱に、読者の感情を加入動機へ転換する。',
    image: '/assets/migrated/f1682af4ad4f8f2322c1.webp',
  },
  {
    id: 'amino-index',
    title: 'amino index',
    category: 'Brand Strategy / Communication',
    year: '2021',
    role: 'Brand Strategy / CX & Communication Planning / Copy / Logo / Web',
    issue: '検査サービスから、継続的な健康行動へつながるブランド体験への拡張。',
    value: '「知る」から「行動の変化」へ。数値を自己理解のツールにする。',
    image: '/assets/migrated/11afc223bd9c26f559d7.png',
  },
  {
    id: 'unite-card',
    title: 'UNiTe Card',
    category: 'Brand / Retail / TV-CM',
    year: '2021–2022',
    role: 'VI / Brand Strategy / Naming / Logo / Retail / Web / TV-CM',
    issue: '新ポイントカードを、機能説明だけではなく地域生活者との関係を示すブランドとして立ち上げる。',
    value: '「貯まる」から「つながる」へ。店舗・地域・生活者をつなぐ関係性の設計。',
    image: '/assets/migrated/e2bcd84c6a6759dcca16.png',
  },
  {
    id: 'sheaful-wellbeing',
    title: 'シアフル Well-being アプリ UX/UI リデザイン',
    category: 'UX/UI / Behavioral Design / Well-being',
    year: '2025',
    role: 'UX Design / Behavioral Design / Service Design',
    issue: 'シアフルアプリの継続使用率が伸び悩み。診断体験後の日常利用が弱く、Well-being as a Serviceの入口施策としての継続的会員基盤が構築できていない。診断までは興味を持つが、診断後の体験が期待を超えない状態。',
    value: '「習慣化」を軸に、診断後の「推奨→行動→記録」サイクルを再設計。ビヘイビアデザインと自己決定理論を底流に、自発的に続けたくなる体験を構築する。',
    image: '/assets/migrated/dadee656193160a35a81.webp',
  },
  {
    id: 'marubeni-packetmate',
    title: '丸紅+TISI パケメイト',
    category: 'Branding / Service / Business Design',
    year: '2024',
    role: 'Brand Strategy / VI / Web / Communication / Creative Direction',
    issue: 'ジョイントベンチャーとしての新しいブランド「パケメイト」の立ち上げ。物流・梱包領域における新しいサービスブランドとしての認知構築。',
    value: '「梱包」はコストではなく、物流の価値を高める体験。そこにブランドの軸を置く。',
    image: '/assets/migrated/d7f7499f46342f6c9816.webp',
  },
  {
    id: 'jtb-web3',
    title: 'JTB × web3 FAN Tourism — 旅と地域を結ぶ新戦略',
    category: 'Business / Service / Digital',
    year: '2024',
    role: 'Business Design / Service Design / CX Planning',
    issue: '観光体験が「訪れる」で終わり、旅行後の愛着や継続的な地域との関係につながりにくい。',
    value: '旅の体験を、WEB3で地域への継続的な応援と関係づくりへ繋げる企画。',
    image: '/assets/migrated/db1d1d1a3b0cc4f2060b.png',
  },
  {
    id: 'remo-cart',
    title: 'REMO CART',
    category: 'Service Brand / App / Retail',
    year: '2022',
    role: 'Service Design / Brand Strategy / CX Planning',
    issue: '買い物体験のなかで、荷物運搬という課題が生活者の手間として放置されていた。',
    value: '単なる運搬道具ではなく「買い物を楽しくする伴走者」として捉え直すと、価値が広がる。',
    image: '/assets/migrated/4ed08731fe9847b9b0e3.png',
  },
  {
    id: 'saitama-wood-terrace',
    title: 'SAITAMA WOOD TERRACE',
    category: 'Brand Story / Motion / Promotion',
    year: '2025',
    role: 'Creative Direction / Motion / Communication',
    issue: 'ウッドテラスというブランドのコンセプトと価値を、映像を通じて生活者に伝える。',
    value: '「木と暮らす」という体験の豊かさを、映像の質感・音楽・編集リズムで表現する。',
    image: '/assets/migrated/9c224fa8d10550998358.png',
  },
];

/* =====================
   CAPABILITY TAGS (each project can belong to multiple)
   ===================== */
export const projectCapabilities: Record<string, string[]> = {
  'aizu-coin': ['brand-strategy', 'cx-planning', 'communication-strategy'],
  'regional-currency-20': ['business-design', 'cx-planning', 'brand-strategy'],
  'baby-me-belk': ['brand-strategy', 'cx-planning'],
  'amino-index': ['brand-strategy', 'communication-strategy'],
  'unite-card': ['brand-strategy', 'communication-strategy'],
  'saitama-wood-terrace': ['brand-strategy', 'communication-strategy'],
  reganet: ['brand-strategy'],
  'aseed-aster': ['brand-strategy', 'communication-strategy'],
  'chefs-pride': ['brand-strategy'],
  'q-sai-aojiru': ['brand-strategy', 'communication-strategy'],
  'marubeni-packetmate': ['business-design', 'brand-strategy'],
  'aizu-coin-design-guideline': ['brand-strategy', 'communication-strategy'],
  'green-infra': ['brand-strategy', 'cx-planning'],
  'remo-cart': ['business-design', 'cx-planning'],
  'token-branding': ['business-design', 'brand-strategy'],
  'jtb-web3': ['business-design', 'cx-planning'],
  'fujitsu-recruit': ['cx-planning', 'brand-strategy', 'communication-strategy'],
  'sompo-himawari': ['brand-strategy', 'communication-strategy'],
  'sb-cs': ['brand-strategy', 'communication-strategy'],
  'hitachi-solutions': ['brand-strategy', 'communication-strategy'],
  'hitachi-social': ['cx-planning', 'communication-strategy'],
  'ctc-system': ['cx-planning', 'communication-strategy'],

  'aqua-park-shinagawa': ['brand-strategy', 'communication-strategy', 'cx-planning'],
  'nisshin-wanokiwami': ['cx-planning'],
  'nisshin-seven-musubi': ['cx-planning'],
  'tokyo-gas-eco': ['cx-planning'],
  'j-milk-dietetic': ['cx-planning'],
  'baby-me-event': ['cx-planning', 'brand-strategy'],
  'jww-tisi': ['cx-planning', 'business-design'],
  'kinsho-65th': ['communication-strategy'],
  transino: ['communication-strategy'],
  'android-retail': ['communication-strategy'],
  'saran-wrap': ['communication-strategy'],
  'otona-furikake': ['communication-strategy', 'business-design'],
  patex: ['communication-strategy'],
  soflan: ['communication-strategy', 'cx-planning'],
  ziploc: ['communication-strategy', 'cx-planning'],
  'nisshin-petfood-tvcm': ['communication-strategy'],
  'unite-card-tvcm': ['communication-strategy'],
  'paper-glass': ['communication-strategy'],
  'android-promo': ['communication-strategy'],
  'kao-info': ['communication-strategy'],
  'plus-keshipon': ['communication-strategy'],
  'origin-design-thinking': ['cx-planning', 'brand-strategy'],
};

/* =====================
   ALL WORKS / ARCHIVE CAPABILITY CATEGORIES
   ===================== */
export const archiveCategories = [
  {
    key: 'brand-cx',
    label: 'Brand / CX',
    ja: 'ブランド・CX',
    caption: 'ブランド戦略、CX設計、VI、ネーミング、コミュニケーション',
    items: allWorks.filter((w) => w.category === 'brand-cx' || w.extraCategories?.includes('brand-cx')),
  },
  {
    key: 'digital-service',
    label: 'Digital / Service',
    ja: 'デジタル・サービス',
    caption: 'サービスデザイン、Web、UX/UI、デジタルプラットフォーム、採用ブランディング',
    items: allWorks.filter((w) => w.category === 'digital-service' || w.extraCategories?.includes('digital-service')),
  },
  {
    key: 'experience-space',
    label: 'Experience / Space',
    ja: '体験・空間',
    caption: 'イベント、空間、体験デザイン、施設リブランディング、展示会',
    items: allWorks.filter((w) => w.category === 'experience-space' || w.extraCategories?.includes('experience-space')),
  },
  {
    key: 'retail-communication',
    label: 'Retail / Communication',
    ja: 'リテール・コミュニケーション',
    caption: 'リテール、販促、キャンペーン、商品コミュニケーション、SP',
    items: allWorks.filter((w) => w.category === 'retail-communication' || w.extraCategories?.includes('retail-communication')),
  },
  {
    key: 'creative-movie',
    label: 'Creative / Movie',
    ja: 'クリエイティブ・映像',
    caption: '映像、TV-CM、プロモーション、ローンチ、クリエイティブ',
    items: allWorks.filter((w) => w.category === 'creative-movie' || w.extraCategories?.includes('creative-movie')),
  },
];

/* =====================
   CAREER EVOLUTION
   ===================== */
export const careerEvolution = [
  {
    phase: 'CRAFT',
    sub: 'Graphic / Sign / Spatial',
    years: '2004–2007',
    company: 'ノムラコムス',
    desc: '空間・サイン・環境グラフィックから、人の認知・視認性・導線を設計。認知心理学とデザインの関係性を実務で体得。',
  },
  {
    phase: 'EXPAND',
    sub: 'Retail / SP / Promotion',
    years: '2007–2014',
    company: 'レンゴー',
    desc: '購買行動と売場体験を起点に、リテールコミュニケーションへ拡張。ショッパーの視点から課題を構造化する力を身につける。',
  },
  {
    phase: 'INTEGRATE',
    sub: 'Advertising / Brand / Digital',
    years: '2014–2019',
    company: '電通プロモーション',
    desc: '広告・イベント・映像・デジタルを横断し、統合コミュニケーション設計へ。クリエイティブディレクションの実践を積む。',
  },
  {
    phase: 'EVOLVE',
    sub: 'Brand / Digital / CX',
    years: '2019–2023',
    company: 'ascon',
    desc: 'ブランド戦略、採用、Web、サービス体験まで、上流設計から実装まで一体で推進。CXと事業をつなぐ視点を獲得。',
  },
  {
    phase: 'NOW',
    sub: 'Business / CX / Brand Integration',
    years: '2023–Present',
    company: 'TISI',
    desc: '事業・地域・社会課題を起点に、Business Design / CX / Brand / Communicationを統合。課題の上流から顧客体験の末端まで一貫してリード。',
  },
];

/* =====================
   MARQUEE
   ===================== */
export const marqueeWords = [
  'Business Design',
  'CX Planning',
  'Brand Strategy',
  'Communication Strategy',
  'Service Design',
  'Experience Design',
  'Creative Direction',
];

/* =====================
   CASE DETAIL TYPES & RE-EXPORT
   ===================== */
export interface CaseDetail {
  id: string;
  project: string;
  client: string;
  year: string;
  category: string;
  role: string;
  issue: string;
  challenge: string;
  insight: string;
  strategy: string;
  experience: string;
  output: string;
  impact: string;
  images: { src: string; caption: string; large?: boolean }[];
  videos?: { src?: string; caption: string }[];
}

// caseDetails is defined in caseDetails.ts and re-exported here for backwards compatibility
export { caseDetails } from './caseDetails';